import { computed, observable, makeObservable } from 'mobx';
import { T, Translate } from '../../i18n';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { IMithrilComponent } from '../mithril.component';
import { CSS } from './message.banner.style';

export class MessageBannerComponent extends IMithrilComponent {
	name = 'MessageBanner';
	@observable bannerVisible: boolean = false;

	constructor() {
		super();
		makeObservable(this);
	}

	@computed get nodes(): MithrilVNode {
		if (this.bannerVisible) {
			return m('div', { className: CSS.alert }, [
				m('span', { className: CSS.message }, [
					Translate(T.BANNER_MESSAGE_PT1),
					m(
						'a',
						{ className: CSS.alertHref, href: 'https://ikegps.com/support/sso-for-ike/', target: '_blank' },
						Translate(T.HERE)
					),
					Translate(T.BANNER_MESSAGE_PT2),
				]),
				m(
					'button',
					{
						className: CSS.closeButton,
						onclick: () => {
							this.bannerVisible = false;
						},
						title: T.CLOSE,
					},
					[
						Translate(T.DISMISS),
						Icon.view(MaterialIcon.CLOSE, {
							className: CSS.closeIcon,
						}),
					]
				),
			]);
		}
		return null;
	}
}
